// extracted by mini-css-extract-plugin
export default {"redIcon":"MedicalProfile_redIcon__GSJnh"};